module.exports = __webpack_public_path__ + "img/5-disabled.101d3706.png";